import { getRequest, getRequestDownloadFile } from 'Services/baseRequests/getRequest'
import { postRequest, postRequestDownloadFile } from 'Services/baseRequests/postRequest'
import { RequestResponse } from 'Services/apiResponseTypes'

export const downloadInvoiceRevenueReport = async (
  month: string,
  year: string
): Promise<RequestResponse<ArrayBuffer>> => {
  const response = await getRequestDownloadFile(
    `/admin/invoices/revenue_report?month=${month}&year=${year}`,
    { responseType: 'arraybuffer' }
  )

  return response
    ? {
        success: true,
        statusCode: response.statusCode ?? undefined,
        message: '',
        data: response.data
      }
    : {
        success: false,
        message: '',
        data: undefined
      }
}

export const downloadBenefitRecipientsOverviewReport = async (
  employerId: number,
  day: number,
  month: number,
  year: number
): Promise<RequestResponse> => {
  const response = await getRequest(
    `/employers/${employerId}/users/reports/benefits_recipients_overview?day=${day}&month=${month}&year=${year}`
  )

  return {
    success: response?.success ?? false,
    message: ''
  }
}

export const downloadPurchasesReport = async (
  employerId: number,
  date: string
): Promise<RequestResponse<ArrayBuffer>> => {
  const response = await getRequestDownloadFile(
    `/employers/${employerId}/users/reports/purchases_report?date=${date}`,
    { responseType: 'arraybuffer' }
  )

  return response
    ? {
        success: true,
        statusCode: response.statusCode ?? undefined,
        message: '',
        data: response.data
      }
    : {
        success: false,
        message: '',
        data: undefined
      }
}

export const downloadInvoicesReport = async (
  employerId: number,
  date: string
): Promise<RequestResponse<ArrayBuffer>> => {
  const response = await getRequestDownloadFile(
    `/employers/${employerId}/invoices/bulk_csv?date=${date}`,
    { responseType: 'arraybuffer' }
  )

  return response
    ? {
        success: true,
        statusCode: response.statusCode ?? undefined,
        message: '',
        data: response.data
      }
    : {
        success: false,
        message: '',
        data: undefined
      }
}

export const generateConsolidatedPurchasesReport = async (
  employerId: number,
  startDate: string,
  endDate: string,
  reportName: string,
  countryCode: string
): Promise<RequestResponse> => {
  const response = await postRequest(
    `/employers/${employerId}/users/reports/consolidated_purchases_report`,
    {
      start_date: startDate,
      end_date: endDate,
      report_name: reportName,
      country_code: countryCode
    }
  )

  return response && response.statusCode === 200
    ? {
        success: true,
        statusCode: response.statusCode ?? undefined,
        message: ''
      }
    : {
        success: false,
        message: '',
        data: undefined
      }
}

export const generatePurchaseReport = async (
  employerId: number,
  date: string,
  countryCode: string
): Promise<RequestResponse> => {
  const response = await postRequest(
    `/employers/${employerId}/users/reports/generate_purchase_report`,
    {
      date: date,
      country_code: countryCode
    }
  )

  return response && response.statusCode === 200
    ? {
        success: true,
        statusCode: response.statusCode ?? undefined,
        message: ''
      }
    : {
        success: false,
        message: '',
        data: undefined
      }
}

export const downloadCompletePurchasesReport = async (
  employerId: number,
  date: string,
  countryCode?: string
): Promise<{ data: ArrayBuffer; statusCode?: number } | undefined> =>
  await postRequestDownloadFile(
    `/employers/${employerId}/users/reports/complete_purchases_report`,
    { date, country_code: countryCode },
    {
      responseType: 'blob',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    }
  )
